import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "../../assets/styles/Container";

const AboutUs = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Container>
      <Box>
        <Grid container spacing={4} direction={isMd ? "row" : "column"}>
          <Grid item container alignItems={"center"} xs={12} md={6}>
            <Box>
              <Typography variant={"h4"} gutterBottom sx={{ fontWeight: 700 }}>
                About Us
              </Typography>
              <Typography component={"p"}>
                Newcomerneeds.com is a job portal website specifically designed for newcomers to Canada. Our website is aimed at providing job opportunities and resources to help immigrants find their
                footing in the Canadian job market. We recognize the unique challenges that newcomers face when looking for employment, and our goal is to help them navigate those challenges by
                offering them the tools they need to succeed.
                <br />
                Our website offers a user-friendly interface that allows job seekers to search for jobs by industry, location, and experience level. We also provide a wealth of resources, including
                career advice, resume tips, and job interview coaching. Our team of experts is dedicated to helping newcomers overcome the barriers they may face when entering the Canadian job market,
                and we work tirelessly to connect them with employers who are looking for their skills and experience.
                <br />
                At Newcomerneeds.com, we understand that finding a job is not just about finding a source of income; it's about building a new life in a new country. That's why we are committed to
                helping newcomers succeed in Canada, both professionally and personally. Our website is designed to provide job seekers with the support they need to achieve their goals and build a
                successful future in Canada.{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item container justifyContent="center" alignItems="center" xs={12} md={6}>
            <Box maxWidth={500} width={1}>
              <Box
                component={"img"}
                src={"https://firebasestorage.googleapis.com/v0/b/hireimm1759.appspot.com/o/photos%2Felyse-turton-uwrWzRKRd3M-unsplash.jpg?alt=media&token=672709d8-c188-4616-ac99-b84cacec353b"}
                width={1}
                height={1}
                sx={{
                  filter: theme.palette.mode === "dark" ? "brightness(0.8)" : "none",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default AboutUs;
